<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>产品资料</span>
        <span>点击查看产品资料大纲</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div
        class="content-item"
        v-for="(item, index) in productType"
        :key="index"
        @click="toUrl(item.link)"
      >
        <!-- 产品类型标题 -->
        <div class="title" v-if="item.data.length > 0">
          <div><span></span></div>
          <div>
            {{ item.label }}
          </div>
        </div>
        <!-- 产品列表 -->
        <div class="box" v-if="item.data.length > 0">
          <!-- 产品 -->
          <div
            class="item"
            v-for="(items, indexx) in item.data"
            :key="indexx"
            @click="toUrl(items.link)"
          >
            <img :src="items.logo" alt="" />
            <span>{{ items.articleName }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getXcArticleAll } from "@/api/productInformation.js";
import { getCus as cusGetDict } from "@/api/dictDetail.js";
import { Dialog, Toast } from "vant";
import Vue from "vue";
Vue.use(Toast);
export default {
  created() {
    this.getProductType();
  },

  data() {
    return {
      dataList: {},
      productType: [],
    };
  },

  mounted() {},

  methods: {
    // 获取产品类型
    getProductType() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      cusGetDict("product_article_type")
        .then((res) => {
          res.sort((a, b) => {
            return a.sort - b.sort;
          });
          res.forEach((item) => {
            item.data = [];
          });
          this.productType = res;
          console.log("this.productType", this.productType);
          this.getProductList();
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    // 获取产品资料列表
    getProductList() {
      getXcArticleAll({
        page: 0,
        size: 999,
        sort: "desc",
      })
        .then((res) => {
          let o = res.content;
          o.sort((a, b) => {
            return a.sort - b.sort;
          });
          o.forEach((item) => {
            if (item.type) {
              if (item.status == "up") {
                let a = this.productType.find((items) => {
                  return items.value == item.type;
                });
                a.data.push(item);
              }
            }
          });
          Toast.clear();
          console.log("this.productType", this.productType);
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    // 查看产品文档
    toUrl(url) {
      if (url) {
        window.open(url);
        // Dialog.confirm({
        //   title: "提示",
        //   message: "是否离开当前页面？",
        // })
        //   .then(() => {
        //     window.open(url);
        //   })
        //   .catch(() => {
        //     // on cancel
        //   });
      }
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/productInformation/index.vue